export enum DictionariesViewTypes {
    ManageDicts = 1,
    ManageDictProposals,
}